"use strict";
var arrayToReversed = require("../internals/array-to-reversed");
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
exportTypedArrayMethod("toReversed", function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});
